import type { ListDependenciesReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";

export class AlternativesViewDependenciesDialogViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    id: string | null = null;
    name: string | null = null;
    data: ListDependenciesReadModel | null = null;
    get dependenciesCount(): number | null { return this.data?.Count ?? null; }
    get hasDependants(): boolean | null { return this.data?.HasDependants ?? null; }
    get reports() { return this.data?.Reports ?? []; }
    get lists() { return this.data?.Lists ?? []; }
    get estimationsSurveys() { return this.data?.EstimationsSurveys ?? []; }

    show(id: string, name: string)
    {
        this.initialized = false;

        this.id = id;
        this.name = name;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.name = null;
        this.data = null;
    }

    setData(data: ListDependenciesReadModel)
    {
        this.data = data;
        this.initialized = true;
    }
}